var map = {
	"./GIF_01_nakama.gif": 47255,
	"./GIF_02_koe.gif": 48532,
	"./GIF_03_basho.gif": 73867,
	"./GIF_04_katsudo.gif": 41021,
	"./privacy_mark.gif": 79228
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 93821;